import React, { memo } from 'react'

function ToggleButton({ className, onclick, ml = 'ml10' }) {
    return (
        <div className={'toggle--button  m-m0 ' + ml + ' ' + className} onClick={onclick} role='presentation'>
            <div className='button'></div>
        </div>
    )
}


export default memo(ToggleButton)